import { addBreadcrumb } from '@sentry/angular';
import { ActionReducer } from '@ngrx/store';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ngrxSentryBreadcrumb(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    addBreadcrumb({
      type: 'NGRX',
      message: action.type,
      level: 'info',
      category: 'triggered',
      data: action,
    });

    return reducer(state, action);
  };
}
